export const parseSmartPortfolioJSON = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target.result);
        
        // Handle different possible structures (Dashboard export vs direct list)
        // Dashboard export has { data: { portfolioItems: [...] } }
        let portfolioItems = [];
        
        if (json.data && Array.isArray(json.data.portfolioItems)) {
          portfolioItems = json.data.portfolioItems;
        } else if (Array.isArray(json.portfolioItems)) {
          portfolioItems = json.portfolioItems;
        } else if (Array.isArray(json)) {
          // If it's just an array, assume it's the items list
          portfolioItems = json;
        } else {
          throw new Error('Geçersiz Smart Portfolio JSON yapısı. "data.portfolioItems" veya "portfolioItems" bulunamadı.');
        }

        const positions = [];

        // Recursive function to extract positions
        const extractPositions = (categoryItems) => {
          categoryItems.forEach(category => {
            // Process Items directly under Category
            if (category.items && Array.isArray(category.items)) {
              category.items.forEach(item => {
                if (item.symbol) {
                  positions.push(normalizePosition(item));
                }
              });
            }

            // Process SubCategories
            if (category.subCategories && Array.isArray(category.subCategories)) {
              category.subCategories.forEach(subCat => {
                if (subCat.items && Array.isArray(subCat.items)) {
                  subCat.items.forEach(item => {
                    if (item.symbol) {
                      positions.push(normalizePosition(item));
                    }
                  });
                }
              });
            }
          });
        };

        extractPositions(portfolioItems);

        // Attach configuration structure to the array for use in ImportData.js
        // We use a non-enumerable property or just a property to pass it along
        positions.portfolioConfigItems = portfolioItems;

        resolve(positions);

      } catch (err) {
        console.error("JSON Parse Error:", err);
        reject(new Error('JSON dosyası okunamadı: ' + err.message));
      }
    };

    reader.onerror = () => reject(new Error('Dosya okuma hatası'));
    reader.readAsText(file);
  });
};

const normalizePosition = (item) => {
  // Map fields from export format to ImportData table format
  return {
    symbol: item.symbol,
    shares: Number(item.quantity) || 0,
    price: Number(item.lastPrice) || Number(item.currentPrice) || 0,
    cost: Number(item.avgCost) || 0,
    total: Number(item.value) || (Number(item.quantity) * (Number(item.lastPrice) || 0)),
    // Optional fields if available
    currency: item.currency || 'USD',
    exchange: item.exchange || 'US',
    type: item.type || 'STK'
  };
};
